import apiClient from "./apiClient";

export interface RenderReportRequest {
  reportPath: string;
  format?: string;
  // Each parameter maps to its value(s); multi-value SSRS parameters carry several. The API
  // emits repeated query keys (ClientID=2&ClientID=18) for these.
  parameters?: Record<string, string[]>;
}

export interface SsrsReportInfo {
  id: string;
  name: string;
  path: string;
  description?: string | null;
  viewerUrl?: string | null;
}

export interface SsrsParameterValue {
  label: string;
  value: string;
}

export interface SsrsParameterDefinition {
  name: string;
  prompt?: string | null;
  parameterTypeName?: string | null;
  nullable: boolean;
  allowBlank: boolean;
  multiValue: boolean;
  isQueryParameter: boolean;
  defaultValues?: string[] | null;
  validValues?: SsrsParameterValue[] | null;
  dependencies?: string[] | null;
}

const renderReport = async (request: RenderReportRequest): Promise<Blob> => {
  return apiClient.postBlob(`/reports/render`, {
    reportPath: request.reportPath,
    format: request.format ?? "PDF",
    parameters: request.parameters ?? {},
  });
};

const listReports = async (): Promise<SsrsReportInfo[]> => {
  return apiClient.get<undefined, SsrsReportInfo[]>(`/reports`);
};

const getParameters = async (reportId: string): Promise<SsrsParameterDefinition[]> => {
  return apiClient.get<undefined, SsrsParameterDefinition[]>(
    `/reports/parameters?id=${encodeURIComponent(reportId)}`
  );
};

const getParametersWithValues = async (
  reportPath: string,
  values: Record<string, string[]>
): Promise<SsrsParameterDefinition[]> => {
  return apiClient.post<{ path: string; values: Record<string, string[]> }, SsrsParameterDefinition[]>(
    `/reports/parameters`,
    { path: reportPath, values }
  );
};

const ReportsService = {
  renderReport,
  listReports,
  getParameters,
  getParametersWithValues,
};

export default ReportsService;
